export const mysteryLightTheme = {
  '--mystery-bgc-1': '#425771',
  '--mystery-bgc-2': 'rgba(35, 46, 58, 0.75)',
  '--mystery-bgc-3': 'rgba(255, 255, 255, 0.2)',
  '--mystery-bgc-4': 'rgba(101, 213, 255, 0.05)',
  '--mystery-bgc-5': 'rgba(34, 46, 61, 0.00)',
  '--mystery-font-c-1': '#333',
  '--mystery-font-c-2': '#fff',
  '--mystery-font-c-3': '#65d5ff',
  '--mystery-border-c-1': '#65d5ff',
}
export const mysteryDarkTheme = {
  '--mystery-bgc-1': '#425771',
  '--mystery-bgc-2': 'rgba(35, 46, 58, 0.75)',
  '--mystery-bgc-3': 'rgba(255, 255, 255, 0.2)',
  '--mystery-bgc-4': 'rgba(101, 213, 255, 0.05)',
  '--mystery-bgc-5': 'rgba(34, 46, 61, 0.00)',
  '--mystery-font-c-1': '#fff',
  '--mystery-font-c-2': '#fff',
  '--mystery-font-c-3': '#65d5ff',
  '--mystery-border-c-1': '#65d5ff',
}
